export default "assets/images/icons/cart-92642c3f.svg";